<template>
    <div
        class="live-room"
        :class="{ 'live-room--mobile-stack': liveRoomLayoutMobile }"
        element-loading-text="连接中"
        v-if="roomId"
    >
        <!-- 手机端宫格布局与 PC 三栏布局切换（仅本页） -->
        <button
            v-if="isLiveRoomPage"
            type="button"
            class="live-room-layout-toggle"
            :title="liveRoomLayoutMobile ? '切换为电脑端布局' : '切换为手机端布局'"
            :aria-label="liveRoomLayoutMobile ? '切换为电脑端布局' : '切换为手机端布局'"
            :aria-pressed="liveRoomLayoutMobile ? 'true' : 'false'"
            @click="liveRoomLayoutMobile = !liveRoomLayoutMobile"
        >
            <i :class="liveRoomLayoutMobile ? 'el-icon-mobile-phone' : 'el-icon-s-platform'"></i>
        </button>
        <div class="container">
            <div
                class="data-board"
                v-if="roomId && liveState == 1"
                @click="toDataBoard"
            >
                <div class="line">查看</div>
                <div class="line">后台</div>
                <div class="line">数据</div>
            </div>
            <live-script
                class="radius live-core-pane"
                :scriptData="scriptCarousel"
                :liveState="liveState"
                :currentScript="currentScript"
                :layout-mobile-stack="liveRoomLayoutMobile"
            ></live-script>
            <live-main
                class="radius live-core-pane"
                ref="liveMain"
                :room-id="roomId"
                :layout-mobile-stack="liveRoomLayoutMobile"
                :videoTracks="videoData.tracks"
                @start-live.once="sendStarLive"
                @setProp="setProp"
                @setData="handleSetData"
                @changeData="setChangeData"
                @bulletChatChange="setBulletChat"
                @openAudioDialog="openAudioDialog"
                @record="recordLive"
            ></live-main>
            <live-other-info
                class="live-extras-pane"
                :popularityData="popularityData"
                :bulletChatList="bulletChatList"
                :liveState="liveState"
                :liveTime="liveTime"
            ></live-other-info>
        </div>
        <my-dialog
            title="提示"
            :is-show.sync="debugDialog"
            :button-config="debugDialogButton"
            :confirm-handler="startLiveInit"
            :cancel-handler="toDebugger"
            :top="50"
        >
            为了避免直播中的失误，您可以选择先进行直播调试后再开始直播， 或者您也可以选择直接开始。
        </my-dialog>
        <my-dialog
            title="提示"
            :is-show.sync="audioDialog"
            :confirm-handler="() => openAudioHandler(true)"
            :cancel-handler="() => openAudioHandler(false)"
            :top="50"
        >
            是否开启声音？
        </my-dialog>
    </div>
</template>

<script>
import LiveScript from "components/student/liveRoom/LiveScript";
import LiveMain from "components/student/liveRoom/LiveMain";
import LiveOtherInfo from "components/student/liveRoom/LiveOtherInfo";
import MyDialog from "components/common/MyDialog";

import { getSteamLocation, liveRoom_list } from "@/utils/apis.js";
import { isMobileHandsetDevice, supportsGetDisplayMedia } from "@/utils/deviceEnv.js";

export default {
    name: "LiveRoom",
    data() {
        return {
            liveTime: null,
            currentScript: {},
            liveState: 1,
            roomId: void 0,
            connectLoading: false,
            //左侧脚本控制相关
            scriptCarousel: [],
            //右侧直播间信息相关
            popularityData: {
                onlineTotalNum: 0,
                inOnlineNum: 0,
                outOnlineNum: 0,
                dealNum: 0,
                like: 0,
                advertNum: 0,
                roomReward: 0,
                goodsShelvesNum: 0,
            },
            bulletChatList: [],
            //dialog
            debugDialogButton: [{ hidden: true }, { text: "直接开播" }],
            debugDialog: false,
            audioDialog: false,
            audioCallback: null,

            videoData: {
                stream: null,
                tracks: [],
                recorder: null,
            },
            recordVideoFlag: false,
            /** 每次重新开录时递增，避免停止旧 MediaRecorder 时误触发「结束上传」 */
            recordStopGen: 0,
            /** true=手机端宫格布局（上脚本 / 下左视频+右人气）；false=原 PC 三栏 */
            liveRoomLayoutMobile: false,
        };
    },
    provide: function () {
        const { toggleDebugDialog } = this;
        return {
            toggleDebugDialog,
        };
    },
    components: {
        LiveScript,
        LiveMain,
        LiveOtherInfo,
        MyDialog,
    },
    computed: {
        /** 当前路由为直播间页时才展示布局切换按钮 */
        isLiveRoomPage() {
            return this.$route && this.$route.path === "/liveRoom";
        },
    },
    methods: {
        async init() {
            this.useRoomId();
        },
        async useRoomId() {
            const res = await liveRoom_list();
            if (res.code == 200 && res.data.length > 0) {
                this.roomId = res.data[0].id;
                // this.popularityData.like = res.data[0].like;
            }
        },
        setProp({ key, value }) {
            this[key] = value;
        },
        setViewInfo(res) {},
        toggleDebugDialog(state) {
            this.debugDialog = state;
        },
        startLiveInit() {
            if (!this.roomId) {
                this.$message.error("请确保已创建直播间，如已创建请重新刷新网页重试");
                return void 0;
            }
            this.debugDialog = false;
            this.$refs.liveMain.startButtonHandler();
        },
        openAudioDialog(callback) {
            this.audioDialog = true;
            this.audioCallback = callback;
        },
        openAudioHandler(valid) {
            this.audioCallback && this.audioCallback(valid);
            this.audioDialog = false;
        },
        setChangeData(res) {
            const { like, click_likes } = res.data;
            const { leave_online_number, online_total_number, in_online_number, deal_number, online_advert_number, online_room_reward, goods_shelves_number } = res.data;
            const getValue = (value) => (value ? value : 0);
            this.popularityData.outOnlineNum = getValue(leave_online_number);
            this.popularityData.onlineTotalNum = getValue(online_total_number);
            this.popularityData.inOnlineNum = getValue(in_online_number);
            this.popularityData.dealNum = getValue(deal_number);
            this.popularityData.like = getValue(like) + getValue(click_likes);
            this.popularityData.advertNum = getValue(online_advert_number);
            this.popularityData.roomReward = getValue(online_room_reward);
            this.popularityData.goodsShelvesNum = getValue(goods_shelves_number);
            // this.$set(this.userInfo, "fans", getValue(fans));
            // this.$set(this.userInfo, "like", getValue(like));
            // this.ws.send(JSON.stringify(this.wsActions.getScriptInfo));
        },
        handleSetData(res, type) {
            if (type === "likes") {
                this.popularityData.like = Number(this.popularityData.like) + 1;
            }
        },
        setBulletChat(arr) {
            this.bulletChatList = arr;
        },
        toDataBoard() {
            let url = this.$router.resolve({
                name: "studentLiveDatas",
                path: "/livedata/livedatas",
                query: {
                    user_id: localStorage.getItem("studentId"),
                    train_id: localStorage.getItem("train_id"),
                    room_id: this.roomId,
                },
            });
            window.open(url.href, "_blank");
        },
        toDebugger() {
            this.$router.push("/liveDebug");
        },

        // 界面关闭或者退出时，如在直播中设置断线
        setDisconnect() {
            // 直播中状态才需设置断线-直播倒计时状态也需要设置断线
            if (![1, 4].includes(this.liveState)) return; 
            
            const params = {
                id: this.roomId,
            };

            fetch("api/stu/liveRoom/disconnect", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem('studentToken'), // 在 header 中携带 token
                },
                body: JSON.stringify(params),
                keepalive: true, // 让请求在页面关闭后继续执行
            });
        },

        // 直播录屏
        recordLive(type) {
            if (type === "begin") {
                if (!this.recordVideoFlag) {
                    this.recordVideoFlag = true;
                    this.beginRecord(); // 开始录屏
                }
            } else if (type === "end") {
                this.endRecord(); // 结束录屏
            }
        },

        // 开始录制视频
        async beginRecord() {
            console.log("开始录制视频");
            try {
                await this.recordVideo();
            } catch (error) {
                this.recordVideoFlag = false;
                this.$message.error((error && error.message) || "录制启动失败");
            }
        },

        // 结束录制视频
        endRecord() {
            console.log("结束录制视频");
            try {
                if (this.videoData.recorder && this.videoData.recorder.state !== "inactive") {
                    this.videoData.recorder.stop();
                }
            } catch (e) {
                /* ignore */
            }
            if (!this.videoData.stream) return;
            const tracks = this.videoData.stream.getTracks();
            tracks.forEach((track) => {
                try {
                    track.stop();
                } catch (e2) {
                    /* ignore */
                }
            });
        },

        /** 选择浏览器支持的 MediaRecorder 编码（移动端常不支持固定 webm） */
        _pickMediaRecorderMimeType() {
            if (typeof MediaRecorder === "undefined" || !MediaRecorder.isTypeSupported) return "";
            const candidates = [
                "video/webm;codecs=vp9,opus",
                "video/webm;codecs=vp8,opus",
                "video/webm",
                "video/mp4",
            ];
            for (let i = 0; i < candidates.length; i++) {
                if (MediaRecorder.isTypeSupported(candidates[i])) return candidates[i];
            }
            return "";
        },

        /**
         * PC：沿用「当前标签页」分享（Chrome 特性）；手机：仅用标准字段，避免传未知键导致整段 getDisplayMedia 失败。
         */
        async _getDisplayMediaStreamWithFallbacks() {
            if (!supportsGetDisplayMedia()) {
                throw new Error("当前浏览器不支持屏幕录制 API，请在 HTTPS 下使用 Chrome / Edge，或改用电脑端开播。");
            }
            if (isMobileHandsetDevice()) {
                try {
                    return await navigator.mediaDevices.getDisplayMedia({ video: true, audio: true });
                } catch (e1) {
                    return await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
                }
            }
            return await navigator.mediaDevices.getDisplayMedia({
                video: true,
                audio: true,
                preferCurrentTab: true,
                selfBrowserSurface: "include",
            });
        },

        /**
         * 当 getDisplayMedia 不可用或被拒绝时，尝试录制推流预览 video（仅画面、非整页；部分安卓 WebView 可用）。
         */
        async _tryCaptureStreamFromLivePreviewVideo() {
            const pickVideo = () => {
                const root = document.getElementById("live-video");
                if (!root) return null;
                const list = root.querySelectorAll("video");
                for (let i = 0; i < list.length; i++) {
                    const v = list[i];
                    if (v && v.srcObject) return v;
                }
                return null;
            };
            let video = pickVideo();
            if (!video && isMobileHandsetDevice()) {
                await new Promise((r) => setTimeout(r, 800));
                video = pickVideo();
            }
            if (!video || typeof video.captureStream !== "function") return null;
            try {
                return video.captureStream(30);
            } catch (e) {
                return null;
            }
        },

        /** 绑定 MediaRecorder 与结束上传（与原先逻辑一致，抽离便于复用） */
        _startMediaRecorderOnStream(stream) {
            this.videoData.stream = stream;
            const genAtCreate = this.recordStopGen;
            const vt = stream.getVideoTracks && stream.getVideoTracks()[0];
            if (vt) {
                vt.addEventListener("ended", () => {
                    try {
                        if (this.videoData.recorder && this.videoData.recorder.state !== "inactive") {
                            this.videoData.recorder.stop();
                        }
                    } catch (e) {
                        /* ignore */
                    }
                });
            }
            const mimeType = this._pickMediaRecorderMimeType();
            const opts = mimeType ? { mimeType } : {};
            this.videoData.recorder = new MediaRecorder(stream, opts);
            this.videoData.recorder.addEventListener("dataavailable", (event) => {
                if (event.data && event.data.size > 0) {
                    this.videoData.tracks.push(event.data);
                }
            });
            this.videoData.recorder.addEventListener("stop", () => {
                if (genAtCreate !== this.recordStopGen) return;
                this.$refs.liveMain && this.$refs.liveMain.uploadVideo();
            });
            this.videoData.recorder.start(1000);
        },

        // 录制视频
        async recordVideo() {
            this.recordStopGen++;
            this.videoData.tracks = [];
            if (this.videoData.recorder) {
                try {
                    if (this.videoData.recorder.state !== "inactive") this.videoData.recorder.stop();
                } catch (e) {
                    /* ignore */
                }
            }
            this.videoData.recorder = null;
            if (this.videoData.stream) {
                this.videoData.stream.getTracks().forEach((t) => {
                    try {
                        t.stop();
                    } catch (e2) {
                        /* ignore */
                    }
                });
                this.videoData.stream = null;
            }
            let stream = null;
            let usedPreviewCaptureFallback = false;
            if (supportsGetDisplayMedia()) {
                try {
                    stream = await this._getDisplayMediaStreamWithFallbacks();
                } catch (e) {
                    stream = null;
                }
            }
            if (!stream) {
                stream = await this._tryCaptureStreamFromLivePreviewVideo();
                if (stream) usedPreviewCaptureFallback = true;
            }
            if (!stream) {
                const hint = isMobileHandsetDevice()
                    ? "无法开始录屏：请使用 Chrome 并在系统弹窗中选择要分享的内容；若本机不支持屏幕分享，将尝试仅录制直播预览。仍失败请使用电脑端 Chrome 开播。"
                    : "无法开始录屏，请检查浏览器权限或使用 HTTPS。";
                throw new Error(hint);
            }
            if (usedPreviewCaptureFallback) {
                this.$message.info("当前浏览器未支持整页屏幕分享或已拒绝授权，已改为录制直播预览画面。");
            }
            this._startMediaRecorderOnStream(stream);
        },
    },
    mounted() {
        this.scriptId = localStorage.getItem("scriptId");
        this.init();

        const _this = this;
        window.addEventListener("unload", () => {
            _this.endRecord();

            _this.setDisconnect();
        });

        // window.addEventListener("beforeunload", (event) => {
        //     event.preventDefault();
        //     event.returnValue = ""; // 现代浏览器必须设置这个值，才能显示默认提示框
        // });
    },
    beforeDestroy() {
        this.endRecord();

        this.setDisconnect();
    },
};
</script>

<style scoped lang="scss">
/** 与 PC 三栏布局一致的最小宽度；窄屏通过外层滚动查看，不做纵向堆叠自适应 */
$live-room-layout-min-width: 1320px;

.live-room {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-width: 1920px;
    min-height: 980px;
    // overflow-x: auto;
    // overflow-y: auto;
    user-select: none;

    .container {
        position: relative;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: stretch;
        width: 100%;
        height: 100%;
        padding: 20px;
        background-color: #070932;
        /* 三栏不因窄视口被压扁，保持与桌面一致比例 */
        ::v-deep .live-script,
        ::v-deep .live-main,
        ::v-deep .live-other-info {
            flex-shrink: 0;
        }
        .data-board {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
            left: 22px;
            width: 104px;
            height: 93px;
            color: #fff;
            font-size: 14.5px;
            font-weight: 700;
            background: url("../../assets/image/student/live/flag.png") no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
        }
    }

    /* 手机端宫格：上行整宽脚本，下行左视频右人气（各占下半行一半宽度） */
    &.live-room--mobile-stack {
        min-width: 0 !important;
        min-height: 0 !important;
        overflow: auto;

        .container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
            grid-template-areas:
                "script script"
                "main other";
            gap: 10px;
            height: 100%;
            width: 100%;
            min-height: 0;
            padding: 10px;
            flex-direction: unset;
        }

        ::v-deep .live-script {
            grid-area: script;
            flex: none !important;
            width: 100% !important;
            min-width: 0 !important;
            min-height: 0;
            height: 100%;
            max-height: 100%;
        }

        ::v-deep .live-main {
            grid-area: main;
            width: 100% !important;
            max-width: none !important;
            flex: none !important;
            margin: 0 !important;
            min-width: 0 !important;
            min-height: 0;
            height: 100%;
        }

        ::v-deep .live-other-info {
            grid-area: other;
            flex: none !important;
            width: 100% !important;
            min-width: 0 !important;
            min-height: 0;
            height: 100%;
        }

        /* 手机布局下右侧仅保留人气数据，隐藏弹幕区 */
        ::v-deep .live-other-info .bullet-chat {
            display: none !important;
        }

        ::v-deep .live-other-info .popularity {
            flex: 1 !important;
            margin-bottom: 0 !important;
            min-height: 0;
            overflow-y: auto;
        }

        .data-board {
            top: 8px;
            left: 8px;
        }
    }
}

/* 布局切换悬浮按钮：贴右侧垂直居中 */
.live-room-layout-toggle {
    position: fixed;
    right: max(12px, env(safe-area-inset-right, 0px));
    top: 50%;
    transform: translateY(-50%);
    z-index: 3100;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 1px solid rgba(75, 69, 255, 0.45);
    border-radius: 50%;
    background: rgba(12, 14, 63, 0.92);
    color: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;

    i {
        font-size: 20px;
    }
}

.radius {
    box-sizing: border-box;
    border-radius: 20px;
    overflow: hidden;
    /* background-color: #0c0e3f; */
}
::v-deep .popularity,
::v-deep .bullet-chat {
    @extend .radius;
}

</style>
